<template>
    <v-menu
        bottom right offset-y nudge-bottom="23px"
        transition="slide-y-transition"
        max-height="calc(100vh - 88px)"
        content-class="menu-panel"
        :close-on-content-click="false"
        @input="value => isMenuOpened = value"
        :value="isMenuOpened"
    >
        <template v-slot:activator="{on, attrs}">
            <v-btn
                large plain class="rounded-lg"
                :style="{backgroundColor: isMenuOpened ? '#1976d2' : '', minWidth: 'auto', paddingLeft: '12px', paddingRight: '12px'}"
                v-bind="attrs" v-on="on"
            >
                <v-tooltip bottom>
                    <template v-slot:activator="{on, attrs}">
                        <v-icon v-bind="attrs" v-on="on">mdi-account</v-icon>
                    </template>
                    <span>Профиль</span>
                </v-tooltip>
            </v-btn>
        </template>

        <v-container fluid class="panel-heading">
            <h3>Профиль</h3>
        </v-container>

        <v-container fluid>
            <p>Вы вошли как: {{ $store.state.user.username }}</p>
            <p>Роль: {{ $store.state.user.roleLabel }}</p>
            <v-btn block color="secondary" @click="logOut()">
                <v-icon small>mdi-logout</v-icon>
                &nbsp;Выйти
            </v-btn>
        </v-container>
    </v-menu>
</template>


<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class AccountWidget extends Vue
{
    isMenuOpened = false

    hideMenu() {
        this.isMenuOpened = false
    }

    logOut() {
        this.$store.commit('resetUser')
        this.$router.push('/log-in')
        this.hideMenu()
    }
}
</script>
